module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": 100,
      "per-page": 10
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v("\n  ToDO: make request with the next params:\n  " + _vm._s(_vm.queryParams) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c08ccce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-results/SearchResultsPage.vue
// module id = 1398
// module chunks = 1